<script setup>
import { ref, onMounted } from 'vue'
import * as signalR from "@microsoft/signalr";

import { aiService } from "@/services/aiService";
import { aiServiceFetch } from "@/services/aiService";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonInput from "@/components/ArgonInput.vue";


const items = ref([
  { id: 1, text: 'gemma3', value: 'gemma3' },
  { id: 2, text: 'llama3.2', value: 'llama3.2' },
  { id: 3, text: 'smollm2', value: 'smollm2:135m' },
  { id: 4, text: 'bielik', value: 'mwiewior/bielik:latest' },
]);

const aiDataModel = ref({
  model:"gemma3",
  text: "Powiedz mi dowcip o programistach",
  textArea: "",
  guid: crypto.randomUUID()
})

const messageRequest = ref({
  url: window.location.href,
  chatId: crypto.randomUUID(),
  model:"gemma3",
  message: { id: "", role: 'user', content: "" },
})

//---------------------AI SERVICE FETCH
async function CancelRequest() {
  console.log("CancelRequest");
  aiServiceFetch.cancel();
}

async function EmbedingItemsFetch() {

  console.log("EmbedingItemsFetch", aiDataModel.value);
  aiDataModel.value.textArea="";
  
  aiServiceFetch.embedingItemsFetch(aiDataModel.value, (chunk) => {
    aiDataModel.value.textArea += chunk;
  });
}

async function MultiAgentFetch() {

  console.log("MultiAgentFetch", aiDataModel.value);
  aiDataModel.value.textArea="";
  
  aiServiceFetch.multiAgentFetch(aiDataModel.value, (chunk) => {
    aiDataModel.value.textArea += chunk;
  });
}

async function SendMessageFetch() {

  console.log("SendMessageFetch", aiDataModel.value);
  aiDataModel.value.textArea="";
  
  aiServiceFetch.sendMessageFetch(aiDataModel.value, (chunk) => {
    aiDataModel.value.textArea += chunk;
  });
}

async function CustomQueryFetch() {

  console.log("CustomQueryFetch", aiDataModel.value);
  aiDataModel.value.textArea="";
  
  aiServiceFetch.customQueryFetch(aiDataModel.value, (chunk) => {
    aiDataModel.value.textArea += chunk;
  });
}
//---------------------AI SERVICE
async function SendMessage() {

  console.log("SendMessage", aiDataModel.value);

  const result = await aiService.sendMessage(aiDataModel.value);
  
  
  aiDataModel.value.textArea = result;
  aiDataModel.value.text = "";
}
async function ListModels() {

  console.log("listLocalModels");

  const result = await aiService.listLocalModels();
  
  aiDataModel.value.textArea = JSON.stringify(result, null, 0);

}

//---------------------SIGNALR
const API_URL = process.env.VUE_APP_AI_URL;
console.log("API_URL", API_URL);
console.log("API_URL+aiChatSignalHub", API_URL+"aiChatSignalHub");
const connection = new signalR.HubConnectionBuilder()
  //.withUrl("http://localhost:5266/aiChatSignalHub")
  .withUrl(API_URL+"aiChatSignalHub",
    {
    accessTokenFactory: () => localStorage.getItem("authToken")
  })
  .withAutomaticReconnect()
  .build();

connection.on("ReceiveMessage", (data)  => {
  console.log(">>ReceiveMessage",data);
   aiDataModel.value.textArea += data.content;
});

connection.on("EndMessage", () => {
  console.log(">>EndMessage");
});

connection.on("AIController", (data) => {
   //console.log(">>AIController",data);
   aiDataModel.value.textArea += data;
});

const send = async () => {
  console.log(">>send");
  aiDataModel.value.textArea="";
  messageRequest.value.model = aiDataModel.value.model; 
  messageRequest.value.message = { id: crypto.randomUUID(), role: 'user', content: aiDataModel.value.text }
  
  await connection.invoke("SendMessage",  messageRequest.value);
 
};

onMounted(async () => {
  await connection.start();
});

//---------------------SIGNALR
</script>
<style scoped>
img {
  max-width: 250px;
  height: auto;
  border: 2px solid #ddd;
  border-radius: 8px;
  margin-top: 10px;
}
</style>
<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="d-flex align-items-center">

      </div>
    </div>
    <hr class="horizontal dark" />
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <label for="example-text-input" class="form-control-label">model</label>
              <select v-model="aiDataModel.model">
                <option disabled value="">Please select one</option>
                <option v-for="item in items" :key="item.id" :value="item.value">
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label for="example-text-input" class="form-control-label">text</label>
              <argon-input type="text" v-model="aiDataModel.text" placeholder="Type here..." id="aiDataModel.text"/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label for="example-text-input" class="form-control-label">action</label>
              <div>
                <argon-button color="success" variant="gradient" @click="SendMessageFetch"><i class="fas fa-plus me-2"></i>Wyślij zapytanie aiServiceFetch</argon-button> |
                 <argon-button color="success" variant="gradient" @click="send"><i class="fas fa-plus me-2"></i>Wyślij zapytanie signalR</argon-button> |
                <argon-button color="dark" variant="gradient" @click="SendMessage"><i class="fas fa-plus me-2"></i>Wyślij zapytanie aiService</argon-button> | 
                <argon-button color="dark" variant="gradient" @click="ListModels"><i class="fas fa-plus me-2"></i>List all models aiService</argon-button> |
                <argon-button color="dark" variant="gradient" @click="CustomQueryFetch"><i class="fas fa-plus me-2"></i>CustomQuery</argon-button> |
                <argon-button color="danger" variant="gradient" @click="CancelRequest"><i class="fas fa-plus me-2"></i>Cancel Request</argon-button> |
                <argon-button color="dark" variant="gradient" @click="EmbedingItemsFetch"><i class="fas fa-plus me-2"></i>EmbedingItemsFetch</argon-button> |
                <argon-button color="dark" variant="gradient" @click="MultiAgentFetch"><i class="fas fa-plus me-2"></i>MultiAgentFetch</argon-button> |
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label for="example-text-input" class="form-control-label">text area</label><br/>
              <span v-html="aiDataModel.textArea" style="white-space: pre-line;"></span>
              <!-- <pre style="background:#1e1e1e;color:#dcdcdc;padding:12px;border-radius:6px">{{ JSON.stringify(aiDataModel.textArea, null, 2) }}</pre> -->
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>
